import { render, staticRenderFns } from "./RouterlinkCell.vue?vue&type=template&id=6c216eb8&scoped=true&"
import script from "./RouterlinkCell.vue?vue&type=script&lang=js&"
export * from "./RouterlinkCell.vue?vue&type=script&lang=js&"
import style0 from "./RouterlinkCell.vue?vue&type=style&index=0&id=6c216eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c216eb8",
  null
  
)

export default component.exports